<template>
    <div
        class="preferredDateTimePg relative mobile:z-[9] laptop:z-[99] mobile:min-h-[500px] tablet:min-h-[700px] laptop:min-h-[600px] largeDesktop:min-h-[700px] rounded-[20px] mobile:p-[5px] laptop:p-[20px] border-[1px] border-[#CCCCCC] bg-[#FFFFFF]/50">
        <div class="rounded-[20px] mobile:p-[15px] laptop:p-[20px] shadow-[0px_0px_10px_0px_#00000026] bg-[#FFFFFF]">
            <h2 class="mobile:text-center tablet:text-left mb-[20px] font-days text-[22px] text-[#2459A8]">File a
                Service Claim</h2>
            <div class="flex flex-wrap justify-between gap-[20px]">
                <SingleSelectDropdown v-for="item in claimConfig" :key="item.name" :options="item.options" required
                    :label="item.title" optionKey="title" selectValueKey="value"
                    :mainSelectDropdownClass="item.title == 'Service Address' ? '!w-[100%]' : 'tablet:!w-[48%] laptop:w-[48.8%] largeDesktop:!w-[49%]'"
                    input-class="text-[#666] font-poppins !p-[10px] 2xl:!px-[15px] 2xl:!py-[0px] !text-[16px] !h-[44px] date-picker mx-input cursor-pointer focus:outline-none !bg-white w-full rounded-full text-left border-[1px] !border-[#CCCCCC] !rounded-[10px] shadow-none"
                    :selectedOptions="item.value" :updateOption="(option, data) => setSelectedOption(item, data)"
                    :fieldName="item.title" :isSearchable="false" />
            </div>
            <div class="my-[20px]">
                <SingleSelectDropdown v-if="isAllSelected && !$helper.isEmpty(agreementAddresses)"
                    :options="agreementAddresses.options" :label="agreementAddresses.title" required optionKey="title"
                    selectValueKey="value"
                    input-class="text-[#666] font-poppins !p-[10px] 2xl:!px-[15px] 2xl:!py-[0px] !text-[16px] !h-[44px] date-picker mx-input cursor-pointer focus:outline-none !bg-white w-full rounded-full text-left border-[1px] !border-[#CCCCCC] !rounded-[10px] shadow-none"
                    :selectedOptions="selectedAddress"
                    :updateOption="(option, data) => setSelectedAddressOption(data, option)"
                    :fieldName="agreementAddresses.title" :isSearchable="false">
                </SingleSelectDropdown>
            </div>

            <!-- {{ claimAgreements }} -->
            <div class="my-[20px]">
                <SingleSelectDropdown v-if="isAddressSelected && !$helper.isEmpty(claimAgreements)"
                    :options="claimAgreements.options" :label="claimAgreements.title" required optionKey="title"
                    selectValueKey="value"
                    input-class="text-[#666] font-poppins !p-[10px] 2xl:!px-[15px] 2xl:!py-[0px] !text-[16px] !h-[44px] date-picker mx-input cursor-pointer focus:outline-none !bg-white w-full rounded-full text-left border-[1px] !border-[#CCCCCC] !rounded-[10px] shadow-none"
                    :selectedOptions="selectedAgreementName"
                    :updateOption="(option, data) => setSelectedAgreementOption(data, option)"
                    :fieldName="claimAgreements.title" :isSearchable="false">
                </SingleSelectDropdown>
            </div>

            <div ref="agreementRef" v-if="selectedAgreement">
                <div v-if="claimConfig?.service_types?.value != '1'"
                    class="grid mobile:grid-cols-1 tablet:grid-cols-3 gap-[20px]">
                    <div class="rounded-[10px] p-[10px] border-[1px] border-[#2459A8] bg-[#2459A8]/5">
                        <h6 class="mb-[2px] text-[14px] font-poppins text-[#666666]">Agreement ID</h6>
                        <p class="leading-snug text-[16px] font-poppins font-medium text-[#333]">{{
                            selectedAgreement.agreement_number }}</p>
                    </div>
                    <div class="rounded-[10px] p-[10px] border-[1px] border-[#F5B134] bg-[#FDF9EE]">
                        <h6 class="mb-[2px] text-[14px] font-poppins text-[#666666]">Coverage Amount</h6>
                        <p class="leading-snug text-[16px] font-poppins font-medium text-[#333]">${{
                            $helper.formatAmount(selectedAgreement.covered_amount) }}</p>
                    </div>
                    <div class="rounded-[10px] p-[10px] border-[1px] border-[#F5B134] bg-[#FDF9EE]">
                        <h6 class="mb-[2px] text-[14px] font-poppins text-[#666666]">Remaining Amount</h6>
                        <p class="leading-snug text-[16px] font-poppins font-medium text-[#333]">${{
                            $helper.formatAmount(selectedAgreement.remaining_balance) }}</p>
                    </div>
                </div>
                <div v-else>
                    <div v-if="selectedAgreement.is_central_heating" class="flex items-center mb-[20px]">
                        <label class="flex items-start cursor-pointer mt-[3px]">
                            <input type="checkbox" v-model="is_boiler_system" class="hidden peer" />
                            <span
                                class="min-w-7 min-h-7 flex items-center justify-center border-[1px] !border-[#ccc] bg-white rounded-md transition">
                                <svg v-if="is_boiler_system == true" class="w-6 h-6 text-blue-600" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" viewBox="0 0 20 20">
                                    <path d="M5 10.5 8.5 14 15 7.5" />
                                </svg>
                            </span>
                        </label>
                        <span
                            class="ml-2 text-[13px] font-normal text-[#666666] text-justify font-poppins leading-tight">
                            Is this a Boiler system?</span>
                    </div>

                    <div class="grid mobile:grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-4 gap-[20px]">

                        <div class="rounded-[10px] p-[10px] border-[1px] border-[#2459A8] bg-[#2459A8]/5">
                            <h6 class="mb-[2px] text-[14px] font-poppins text-[#666666]">Agreement ID</h6>
                            <p class="leading-snug text-[16px] font-poppins font-medium text-[#333]">{{
                                selectedAgreement.agreement_number }}</p>
                        </div>
                        <div class="rounded-[10px] p-[10px] border-[1px] border-[#F5B134] bg-[#FDF9EE]">
                            <h6 class="mb-[2px] text-[14px] font-poppins text-[#666666]">No. of Visits</h6>
                            <p class="leading-snug text-[16px] font-poppins font-medium text-[#333]">
                                {{ selectedAgreement.no_of_visits ?? '0' }}</p>
                        </div>
                        <div class="rounded-[10px] p-[10px] border-[1px] border-[#F5B134] bg-[#FDF9EE]">
                            <h6 class="mb-[2px] text-[14px] font-poppins text-[#666666]">Per Visit Amount</h6>
                            <p class="leading-snug text-[16px] font-poppins font-medium text-[#333]">${{
                                $helper.formatAmount((is_boiler_system && selectedAgreement.is_central_heating) ?
                                    selectedAgreement.boiler_amount : selectedAgreement.per_visit_amount) }}</p>
                        </div>
                        <div class="rounded-[10px] p-[10px] border-[1px] border-[#F5B134] bg-[#FDF9EE]">
                            <h6 class="mb-[2px] text-[14px] font-poppins text-[#666666]">Visits Remaining</h6>
                            <p class="leading-snug text-[16px] font-poppins font-medium text-[#333]">
                                {{ selectedAgreement.visits_remaining }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="selectedAgreement"
                class="flex flex-col gap-[15px] pt-[20px] mt-[20px] border-t border-[#EFEFEF]">
                <div class="grid mobile:grid-cols-1 tablet:grid-cols-3 gap-[20px]">
                    <div>
                        <label class="mb-[3px] text-[14px] font-poppins font-normal text-[#666]">Preferred Date &
                            Time<span class="text-[#f00]">*</span></label>
                        <date-picker v-model:value="preferredDateTime"
                            input-class="!text-[16px] !font-poppins disable-input !rounded-[10px] focus:!outline-none !border-[#ccc] cursor-pointer"
                            type="datetime" format="MM/DD/YYYY hh:mm A" :placeholder="'Select Date'" :confirm="true"
                            :disabled-date="disabledBefore" :disabled-time="disabledBeforeTime" :readonly="false"
                            :append-to-body="false" :append-to="'.preferredDateTimePg'" :clearable="false"
                            :editable="false" value-type="format" class="focus:!border-[#ccc]"
                            :time-title-format="'MM/DD/YYYY'">
                            <template #icon-calendar>
                                <img src="../../assets/images/create-claim-calendar-icon.svg" alt="calendar"
                                    class="w-5 h-5 cursor-pointer" />
                            </template>
                        </date-picker>
                    </div>
                    <div class="incidentDate">
                        <div class="mb-[5px] flex items-center justify-between ">
                            <label class=" text-[14px] font-poppins font-normal text-[#666]">Incident Date
                                <span v-if="!this.isMaintenance" class="text-[#f00]">*</span>
                            </label>
                            <div class="relative group">
                                <!-- Info Icon -->
                                <img src="../../assets/images/plan-info.svg" alt="Info Icon"
                                    class="w-[22px] h-[22px] cursor-pointer" @click.stop="toggleTooltip" />

                                <!-- Tooltip -->
                                <div :class="[
                                    'absolute -right-[10px] top-full mt-2 w-max max-w-[320px]',
                                    'bg-[#2459A8] text-white text-[14px] font-roboto font-normal px-3 py-2 rounded-[10px]',
                                    'border-[1px] border-white shadow-[0_0_10px_0_#00000026]',
                                    'transition-opacity duration-200 pointer-events-none z-[999]',
                                    // Desktop hover
                                    'md:opacity-0 md:group-hover:!opacity-100',
                                    // Mobile click
                                    isOpen ? '!opacity-100' : 'opacity-0'
                                ]">
                                    <!-- Triangle -->
                                    <span class="absolute -top-[12px] right-[14px] w-0 h-0
                border-l-[6px] border-l-transparent
                border-r-[6px] border-r-transparent
                border-b-[12px] border-b-[#2459A8]"></span>

                                    Choose the date when the incident occurred
                                </div>
                            </div>
                        </div>
                        <date-picker v-model:value="incidentDate"
                            input-class="!text-[16px] !font-poppins disable-input !rounded-[10px] focus:!outline-none !border-[#ccc] cursor-pointer"
                            format="MM/DD/YYYY" :placeholder="'Select Date'" :confirm="true" :readonly="false"
                            :disabled-date="disabledAfter" :clearable="false" :editable="false" :append-to-body="false"
                            :append-to="'.preferredDateTimePg'" value-type="format" class=" focus:!border-[#ccc] ">
                            <template #icon-calendar>
                                <img src="../../assets/images/create-claim-calendar-icon.svg" alt="calendar"
                                    class="w-5 h-5 cursor-pointer" />
                            </template>
                        </date-picker>
                    </div>
                    <div>
                        <label for="phoneNumber"
                            class="mb-[3px] text-[14px] font-poppins font-normal text-[#666]">Secondary Phone
                            Number</label>
                        <inputComponent ref="phoneRef" v-model="phone" name="phone" mask="(###) ###-####" type="tel"
                            errorClass="!text-customYellow-100" placeholder="Enter Number"
                            error-message="Invalid phone number"
                            customClass="!text-[16px] font-poppins !p-[9px] !rounded-[10px] !border-[#CCCCCC]" />
                    </div>
                </div>
                <div>
                    <label class="mb-[3px] text-[14px] font-poppins font-normal text-[#666] w-full"
                        for="notes">Issue<span class="text-red-500">*</span></label>
                    <textAreaComponent ref="notesRef" name="notes" v-model="notes" required
                        placeholder="Please describe the issue" length="500"
                        customClass="!text-[16px] !font-poppins resize-none font-poppins font-regular outline-none py-2 px-2 w-full !rounded-[10px] border border-[#cccccc] placeholder:text-[#999] text-[#333]"
                        errorClass="text-[#F5B134]" />
                </div>
                <div class="flex laptop:items-center mobile:items-start">
                    <label class="flex items-start cursor-pointer mt-[3px]">
                        <input type="checkbox" v-model="checkbox" class="hidden peer" />
                        <span
                            class="min-w-7 min-h-7 flex items-center justify-center border-[1px] !border-[#ccc] bg-white rounded-md transition">
                            <svg v-if="checkbox == true" class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 20 20">
                                <path d="M5 10.5 8.5 14 15 7.5" />
                            </svg>
                        </span>
                    </label>
                    <span class="ml-2 text-[12px] font-normal text-[#666666] text-justify font-poppins leading-tight"> I
                        request to
                        enroll this claim under the protection plan and confirm that I have read and understand the <a
                            href="/terms-and-conditions?checkout=1" target="_blank"
                            class="text-[#2459A8] underline cursor-pointer">
                            Terms
                            and
                            Conditions,</a> including coverage limits and exclusions.</span>
                </div>
                <div class="flex items-center justify-center gap-[15px]">
                    <button @click="cancelClicked"
                        class="CustomYellowBtn min-w-[120px] rounded-full px-[30px] py-[7px] tablet:py-[10px] text-[14px] font-poppins border-[1px] border-[#F5B134] bg-[#F5B134] text-[#fff]">Cancel</button>
                    <button :disabled="isButtonDisable" @click="saveClicked"
                        class="CustomBlueBtn min-w-[120px] rounded-full px-[30px] py-[7px] tablet:py-[10px] text-[14px] font-poppins border-[1px] border-[#2459A8] bg-[#2459A8] text-[#fff] disabled:bg-[#ccc] hover:disabled:!bg-none disabled:border-[#ccc] ">Save</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePicker from "vue-datepicker-next";
import "vue-datepicker-next/index.css";
import SingleSelectDropdown from "../../components/partialComponent/singleSelectDropdown.vue";
import inputComponent from "../../components/partialComponent/inputComponent.vue";
import textAreaComponent from "../../components/partialComponent/textAreaComponent.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
import moment from "moment";
import { th } from "date-fns/locale";

export default {
    components: {
        DatePicker,
        SingleSelectDropdown,
        inputComponent,
        textAreaComponent
    },
    data() {
        return {
            preferredDateTime: null,
            incidentDate: null,
            selectedAgreementName: null,
            selectedAgreement: null,
            selectedAddress: null,
            phone: '',
            notes: '',
            checkbox: false,
            isOpen: false,
            is_boiler_system: false,
            isMaintenance: false
        };
    },
    computed: {
        ...mapGetters([
            "claimConfig",
            "agreementAddresses",
            "claimAgreements",
            "agreementDetails",
            "claimResponse"
        ]),

        isAllSelected() {
            // Loop through all keys in the object
            if (Object.values(this.claimConfig).length <= 0) {
                this.selectedAddress = null
                return false
            }
            return Object.values(this.claimConfig).every(item => {
                return item.value != undefined && item.value != null && item.value != '';
            });
        },

        isAddressSelected() {
            return !this.$helper.isEmpty(this.selectedAddress)
        },

        isButtonDisable() {

            if (this.isMaintenance) {
                if (this.$helper.isEmpty(this.preferredDateTime) || this.$helper.isEmpty(this.notes) || !this.checkbox) {
                    return true
                } else {
                    return false
                }
            }
            else {
                if (this.$helper.isEmpty(this.preferredDateTime) || this.$helper.isEmpty(this.incidentDate) || this.$helper.isEmpty(this.notes) || !this.checkbox) {
                    return true
                } else {
                    return false
                }
            }

        }
    },
    watch: {
        agreementDetails: function () {
            this.selectedAgreement = this.agreementDetails
            this.$nextTick(() => {
                const el = this.$refs.agreementRef;
                const yOffset = -100; // 👈 jitna neeche chahiye (px)
                const y =
                    el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                window.scrollTo({
                    top: y,
                    behavior: 'smooth'
                });
            });
        },

        claimResponse: function () {
            toast.success(this.claimResponse.message);
            this.$router.replace({
                name: "workOrders"
            })
        },

        claimAgreements: function () {
            if ((this.claimAgreements?.options ?? []).length == '0') {
                this.$dialog.show({
                    title: "No Active Plan Found",
                    text: "There is no active plan available for the selected address. Please select an address with an active plan or contact support for assistance.",
                    buttonText: "Dismiss",
                    onConfirm: () => {

                    },
                });
            }
        },

        agreementAddresses: function () {
            if ((this.agreementAddresses?.options ?? []).length == '0') {
                this.$dialog.show({
                    title: "Agreement Required",
                    text: "There is no active agreement for the selected service type. Please purchase a plan to proceed.",
                    buttonText: "Dismiss",
                    onConfirm: () => {

                    },
                });
            }
        },
    },
    mounted() {
        this.getClaimConfig();
        window.scrollTo({ top: 0, behavior: 'smooth' })
        document.addEventListener('click', this.closeTooltip)
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeUnmount() {
        document.removeEventListener('click', this.closeTooltip)
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        ...mapActions([
            "getClaimConfig",
            "getAgreementAddress",
            "getClaimAgreements",
            "getAgreementDetails",
            "saveClaim"
        ]),

        disabledBefore: function (date) {
            const cdate = new Date();
            cdate.setHours(0, 0, 0, 0);
            return date < cdate;
        },

        disabledAfter: function (date) {

           const [year, month, day] = this.agreementDetails.activation_date.split('-').map(Number);

            const minDate = new Date(year, month - 1, day); // Local timezone
            minDate.setHours(0, 0, 0, 0);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const current = new Date(date);
            current.setHours(0, 0, 0, 0);

            return current < minDate || current > today;

        },

        disabledBeforeTime: function (date) {
            const hours = date.getHours()
            const minutes = date.getMinutes()

            if (hours < 6) {
                return true
            }

            if (hours > 20 || (hours === 20 && minutes > 0)) {
                return true
            }

            return false
        },


        toggleTooltip() {
            // Enable click only on mobile
            if (window.innerWidth < 768) {
                this.isOpen = !this.isOpen
            }
        },
        closeTooltip() {
            this.isOpen = false
        },
        handleScroll() {
            // Close tooltip on scroll for mobile/tablet
            if (window.innerWidth < 1024 && this.isOpen) {
                this.closeTooltip()
            }
        },
        getRequestParam() {
            let params = {
            }
            let keys = Object.keys(this.claimConfig)
            for (const key of keys) {
                let obj = this.claimConfig[key]
                params[obj.slug] = obj.value

            }

            if (!this.$helper.isEmpty(this.selectedAddress)) {
                params["address_id"] = this.selectedAddress
            }

            return params
        },

        setSelectedAgreementOption(data, option) {
            this.is_boiler_system = ''
            this.selectedAgreementName = data
            this.selectedAgreement = null
            this.resetAgreementFields()
            if (this.selectedAgreementName) {
                this.getAgreementDetails({
                    "item_coverage_id": this.selectedAgreementName
                });
            }
        },

        setSelectedAddressOption(data, option) {
            this.selectedAddress = data
            this.selectedAgreement = null
            this.selectedAgreementName = null
            this.resetAgreementFields()
            if (this.isAddressSelected) {
                this.getClaimAgreements(this.getRequestParam());
            }
        },

        setSelectedOption(item, option) {

            if (item.slug == 'service_id') {

                if (option == 1) {
                    this.isMaintenance = true
                }
                else {
                    this.isMaintenance = false
                }
            }

            item.value = option
            this.selectedAddress = null
            this.selectedAgreement = null
            this.selectedAgreementName = null
            this.resetAgreementFields()
            if (this.isAllSelected) {
                this.getAgreementAddress(this.getRequestParam());
            }

        },
        termsNConClicked() {
            const url = this.$router.resolve({ name: "termsAndConditions" }).href;
            window.open(url, "_blank");
        },


        validateForm() {
            let inputRefer = ["phoneRef"]
            let hasError = false;
            let firstInvalidField = null;
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.validate === "function") {
                    inputComponent.validate();
                    if (inputComponent.hasError && !firstInvalidField) {
                        firstInvalidField = inputComponent; // Store first invalid field
                    }
                    if (inputComponent.hasError()) {
                        hasError = true;
                    }
                }
            });

            return hasError;
        },

        saveClicked() {
            if (!this.validateForm()) {
                const selectedDateTime = moment(this.preferredDateTime, "MM/DD/YYYY hh:mm A");
                const now = moment();

                // Check if selected time is in the past
                if (selectedDateTime.isBefore(now)) {
                    toast.error("You cannot select a past date and time.");
                    return;
                }

                // Check if selected time is within 6:00 AM to 8:00 PM
                const hours = selectedDateTime.hours();
                const minutes = selectedDateTime.minutes();

                if (hours < 6 || hours > 20 || (hours == 20 && minutes > 0)) {
                    toast.error("Please select a time between 6:00 AM and 8:00 PM.");
                    return;
                }

                let payload = this.getRequestParam()

                let notes_ = this.notes
                if (this.is_boiler_system) {
                    notes_ = '"BOILER SYSTEM" \n' + this.notes
                }

                payload["item_coverage_id"] = this.selectedAgreementName
                payload["start_date"] = selectedDateTime.utc().unix();
                payload["incident_date"] = this.incidentDate
                payload["notes"] = notes_
                payload["is_boiler_system"] = this.is_boiler_system ? 1 : 0
                if (!this.$helper.isEmpty(this.phone)) {
                    payload["phone_secondary"] = this.phone
                }
                this.saveClaim(payload)
            }
        },

        resetForm() {
            this.selectedAgreementName = null
            this.selectedAgreement = null
            this.selectedAddress = null
            this.resetAgreementFields()
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }, 10);
        },

        resetAgreementFields() {
            this.preferredDateTime = null
            this.incidentDate = null
            this.phone = ''
            this.notes = ''
            this.checkbox = false
            this.isOpen = false
        },

        cancelClicked() {
            this.$dialog.show({
                title: "Cancel Service Claim",
                text: "Are you sure you want to cancel? Any information you’ve entered will be lost and your service claim will not be submitted.",
                onConfirm: () => {
                    this.$router.replace({
                        name: "dashboard"
                    })
                },
            });
        }

    },
};
</script>

<style>
.preferredDateTimePg .mx-datepicker-popup {
    border-radius: 10px;
    overflow: hidden;
    padding: 5px;
}

.preferredDateTimePg .mx-table-date,
.preferredDateTimePg .mx-time-content {
    font-family: "Poppins", sans-serif;
}

.preferredDateTimePg .mx-calendar-content .cell.active {
    color: #fff !important;
    background-color: #2459A8 !important;
}

.preferredDateTimePg .mx-time-content {
    padding-top: 5px;
}

.preferredDateTimePg .mx-time-column {
    border-left: 0;
    margin: 0 2px;
}

.preferredDateTimePg .mx-calendar-header-label button,
.preferredDateTimePg .mx-time-header-title {
    color: #2459A8;
}

.preferredDateTimePg .mx-table th,
.preferredDateTimePg .mx-table td {
    background: transparent !important;
    color: #333 !important;
}

.preferredDateTimePg .mx-time-column .mx-time-item.active {
    color: #fff;
    background-color: #2459A8;
    font-weight: 700;
    border-radius: 50px;
}

.preferredDateTimePg .mx-datepicker-btn-confirm {
    border-color: #2459A8;
    color: #2459A8;
}

.preferredDateTimePg .mx-datepicker-btn-confirm:hover {
    background-color: #2459A8;
    border-color: #2459A8;
    color: #fff;
}

.preferredDateTimePg .mx-calendar-content .cell.disabled {
    background-color: rgba(239, 239, 239, 0.5) !important;
    color: #ccc !important;
}

.preferredDateTimePg .mx-table-date .today {
    color: #2459A8 !important;
}

.preferredDateTimePg .mx-calendar-header,
.preferredDateTimePg .mx-time-header {
    height: 45px;
}

.preferredDateTimePg .mx-time-header {
    display: flex;
    align-items: center;
    justify-content: center;
}

.preferredDateTimePg .mx-calendar-header-label {
    display: flex;
    align-items: center;
    justify-content: center;
    /* width: 100%; */
    height: 100%;
    margin-top: 10px;
}

@media (min-width: 768px) and (max-width: 992px) {
    .preferredDateTimePg .incidentDate .mx-datepicker-main {
        /* top: -280px !important; */
        left: 50px !important;
    }
}
</style>